"use strict";
/* eslint-disable @typescript-eslint/indent */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemQuality = void 0;
var ItemQuality;
(function (ItemQuality) {
    ItemQuality[ItemQuality["POOR"] = 1] = "POOR";
    ItemQuality[ItemQuality["BELOW_AVERAGE"] = 2] = "BELOW_AVERAGE";
    ItemQuality[ItemQuality["AVERAGE"] = 3] = "AVERAGE";
    ItemQuality[ItemQuality["ABOVE_AVERAGE"] = 4] = "ABOVE_AVERAGE";
    ItemQuality[ItemQuality["PERFECT"] = 5] = "PERFECT";
})(ItemQuality || (exports.ItemQuality = ItemQuality = {}));
